import React from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";

import { useTranslation } from "react-i18next";


function Techstack() {
  const { t } = useTranslation();

  const fallbackValues = [
    "We believe equity is achieved by valuing all voices, fostering inclusion, and empowering individuals to contribute to community well-being.",
    "We create supportive spaces for youth and adults to belong, connect personal growth with social change, and inspire collaboration to tackle shared challenges.",
    "We are dedicated to fairness and equality, working to dismantle systemic barriers and ensure everyone has the opportunity to thrive.",
    "We believe meaningful change occurs when we create equitable opportunities for individuals while also addressing the systemic challenges that impact our world.",
    "We value collaboration as a skill that empowers individuals to work effectively across cultures, navigate team dynamics, and foster mutual learning and growth.",
    "We practice ethical innovation—designing and using technology with responsibility, transparency, and care, so progress strengthens communities rather than leaving people behind.",
  ];

  const translatedValues = t("mission.coreValues.items", { returnObjects: true });
  const values = Array.isArray(translatedValues) && translatedValues.length ? translatedValues : fallbackValues;

  return (
    <Row className="mission-values">
      {values.map((text, index) => (
        <Col key={index} xs={12} md={6} lg={4} className="mission-values-col">
          <Card className="policy-card mission-value-card">
            <Card.Body>
              <blockquote className="blockquote mb-0">
                <p className="about-text mission-value-text">{text}</p>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
